import { links } from '../../../constants/links';
import { modes } from '../constants';

export const getMode = ({ page }) => {
  if (page === links.permits) {
    return modes.permits;
  }

  return modes.transports;
};

export const searchSelector = (state) => state.permitsFilterStore.searchValue;
